import { render, staticRenderFns } from "./SupplierArticles.vue?vue&type=template&id=585323b3&"
import script from "./SupplierArticles.vue?vue&type=script&lang=js&"
export * from "./SupplierArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports